/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { ReleveCompteurDto } from '../models/releve-compteur-dto';


/**
 * Fonctions de gestion des relevés de compteurs
 */
@Injectable({
  providedIn: 'root',
})
export class RelevesCompteursService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation releveCompteurGetList
   */
  static readonly ReleveCompteurGetListPath = '/api/releves-compteurs/list';

  /**
   * Renvoie la liste des relevés de compteurs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `releveCompteurGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  releveCompteurGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ReleveCompteurDto>>> {

    const rb = new RequestBuilder(this.rootUrl, RelevesCompteursService.ReleveCompteurGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ReleveCompteurDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des relevés de compteurs.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `releveCompteurGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  releveCompteurGetList(params?: {
  }): Observable<Array<ReleveCompteurDto>> {

    return this.releveCompteurGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ReleveCompteurDto>>) => r.body as Array<ReleveCompteurDto>)
    );
  }

  /**
   * Path part for operation releveCompteurLoadList
   */
  static readonly ReleveCompteurLoadListPath = '/api/releves-compteurs/load-list';

  /**
   * Renvoie la liste des relevés de compteurs (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `releveCompteurLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  releveCompteurLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, RelevesCompteursService.ReleveCompteurLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des relevés de compteurs (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `releveCompteurLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  releveCompteurLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.releveCompteurLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation releveCompteurGet
   */
  static readonly ReleveCompteurGetPath = '/api/releves-compteurs/{id}';

  /**
   * Renvoie le relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `releveCompteurGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  releveCompteurGet$Response(params: {

    /**
     * Identifiant du relevé de compteur
     */
    id: number;
  }): Observable<StrictHttpResponse<ReleveCompteurDto>> {

    const rb = new RequestBuilder(this.rootUrl, RelevesCompteursService.ReleveCompteurGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReleveCompteurDto>;
      })
    );
  }

  /**
   * Renvoie le relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `releveCompteurGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  releveCompteurGet(params: {

    /**
     * Identifiant du relevé de compteur
     */
    id: number;
  }): Observable<ReleveCompteurDto> {

    return this.releveCompteurGet$Response(params).pipe(
      map((r: StrictHttpResponse<ReleveCompteurDto>) => r.body as ReleveCompteurDto)
    );
  }

  /**
   * Path part for operation releveCompteurPut
   */
  static readonly ReleveCompteurPutPath = '/api/releves-compteurs/{id}';

  /**
   * Met à jour le relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `releveCompteurPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  releveCompteurPut$Response(params: {

    /**
     * Identifiant du relevé de compteur à mettre à jour
     */
    id: number;

    /**
     * Relevé de compteur
     */
    body: ReleveCompteurDto
  }): Observable<StrictHttpResponse<ReleveCompteurDto>> {

    const rb = new RequestBuilder(this.rootUrl, RelevesCompteursService.ReleveCompteurPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReleveCompteurDto>;
      })
    );
  }

  /**
   * Met à jour le relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `releveCompteurPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  releveCompteurPut(params: {

    /**
     * Identifiant du relevé de compteur à mettre à jour
     */
    id: number;

    /**
     * Relevé de compteur
     */
    body: ReleveCompteurDto
  }): Observable<ReleveCompteurDto> {

    return this.releveCompteurPut$Response(params).pipe(
      map((r: StrictHttpResponse<ReleveCompteurDto>) => r.body as ReleveCompteurDto)
    );
  }

  /**
   * Path part for operation releveCompteurDelete
   */
  static readonly ReleveCompteurDeletePath = '/api/releves-compteurs/{id}';

  /**
   * Supprime le relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `releveCompteurDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  releveCompteurDelete$Response(params: {

    /**
     * Identifiant du relevé de compteur à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, RelevesCompteursService.ReleveCompteurDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `releveCompteurDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  releveCompteurDelete(params: {

    /**
     * Identifiant du relevé de compteur à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.releveCompteurDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation releveCompteurPost
   */
  static readonly ReleveCompteurPostPath = '/api/releves-compteurs';

  /**
   * Crée le relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `releveCompteurPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  releveCompteurPost$Response(params: {

    /**
     * Relevé de compteur
     */
    body: ReleveCompteurDto
  }): Observable<StrictHttpResponse<ReleveCompteurDto>> {

    const rb = new RequestBuilder(this.rootUrl, RelevesCompteursService.ReleveCompteurPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReleveCompteurDto>;
      })
    );
  }

  /**
   * Crée le relevé de compteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `releveCompteurPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  releveCompteurPost(params: {

    /**
     * Relevé de compteur
     */
    body: ReleveCompteurDto
  }): Observable<ReleveCompteurDto> {

    return this.releveCompteurPost$Response(params).pipe(
      map((r: StrictHttpResponse<ReleveCompteurDto>) => r.body as ReleveCompteurDto)
    );
  }

}
